import { geistMonoFont } from '@/_style/fonts';

export default function SectionLabel({ children, className = '' }: { children: React.ReactNode; className?: string }) {
	return (
		<p
			className={`${geistMonoFont.className} mb-4 text-xs font-medium tracking-[0.2em] text-pink-400/80 uppercase ${className}`}
		>
			{children}
		</p>
	);
}
